import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setIsExamLaunched, setSubject } from '../../store/actions';
import { subjectDuration, getSubjectStatus, formatDateRange, formatDateRangeShort } from "../../utils/commonFunction.js";
import { Link, useHistory } from "react-router-dom";
import { shortenText } from '../../utils/commonFunction.js';
import { ADMIN_PASSWORD } from "../../utils/Constants";
import Swal from 'sweetalert2';
import Str from '../common/Str';
import moment from 'moment';
import { buildStatusChip } from "./utils/CourseHelperUtils.js";
import { courseStyles } from "./utils/CourseStyles.js";
import { SubjectCardLink, SubjectCardSpan, SubjectSideCard } from "./StyledSubjectSidebar.js";

const PastSubjectList = (props) => {
    const { rows, active, qid, isAdmin, changeSub } = props;
    const dispatch = useDispatch();
    const [subjectId, setSubjectId] = useState(0)
    const history = useHistory();
    const {isWithHeld} = useSelector((state) => state);
    const { examLaunched } = useSelector(state=>state.examLaunched); 
    const renderStatusChip = (subject) => {
        const chip = buildStatusChip(subject.show_results === 1
            ? "Finished"
            : subject?.subjectStatus,
            isWithHeld == true
                ? "witheld"
                : subject?.studentResult?.pass_status || 0,
            isWithHeld == true
                ? "WITHHELD"
                : subject?.studentResult?.gradeText,
            subject?.show_results);
        return (
            <div className="flex justify-start items-center h-full pl-[17px] mt-1">
                <div className="sub-info-lst-rgt">
                    <span style={{ ...courseStyles.chipBase, ...chip.style, color: chip.fontColor || "var(--white)" }}>
                        {chip?.icon ? <i style={{ color: chip.iconColor }} className={chip.icon}></i> : null} {chip.label}
                    </span>
                </div>
            </div>
        );
    }
    const handleSelectSubject = (sid) => {
        if (props.isExamLaunched) {
            if (props.isExamLaunched) {
                Swal.fire({
                    title: 'Are you sure you want to exit?',
                    text: "If you leave the tab, it will change to final!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Leave'
                }).then(function (result) {
                    if (result.isConfirmed) {
                        props.setIsExamLaunchedToFalse()
                        props.parentGetSubContentMethod(sid);
                        if (subjectId !== sid) {
                            dispatch(setSubject({ sid }));
                            setSubjectId(sid);
                        }
                    }
                })
            }
        } else {
            props.parentGetSubContentMethod(sid);
            changeSub()
            if (subjectId !== sid) {
                dispatch(setSubject({ sid }));
                setSubjectId(sid);
            }
        }
    }


    return (
        <>
            <>
                {rows && rows.length > 0 && rows?.map((row) => {
                    return (
                        <SubjectSideCard
                            key={row.intake_id}
                            active={active == (isAdmin == 1 ? row.id : row.intake_id)}
                            disabled={row.subjectStatus === "Not Yet Published"}
                            onClick={() => {
                                if (row.subjectStatus !== "Not Yet Published") {
                                    if (
                                        history.location.pathname === examLaunched?.url &&
                                        examLaunched?.isExamLaunched
                                    ) {
                                        dispatch(setIsExamLaunched({ ...examLaunched, isClicked: true }));
                                    } else {
                                        handleSelectSubject(isAdmin === 1 ? row.id : row.intake_id);
                                    }
                                }
                            }}
                        >

                            {
                                isAdmin == 1 ? (<SubjectCardLink
                                    to={`/courseinfo/${qid}/subject/${row.id}/${ADMIN_PASSWORD}`}>
                                </SubjectCardLink>) : (
                                    history.location.pathname === examLaunched?.url && examLaunched?.isExamLaunched 
                                    ? <SubjectCardSpan
                                    onClick={()=>dispatch(setIsExamLaunched({...examLaunched, isClicked: true}))}
                                    ></SubjectCardSpan>
                                    : <SubjectCardLink
                                    to={row.subjectStatus != "Not Yet Published" ? `/course/${qid}/subject/${row.intake_id}` : "#"}>
                                    </SubjectCardLink>)
                            }

                            
                            <div className='sub_box_name'>
                                <h3 title={row.name}>{shortenText(row.name, 40)}</h3>
                            </div>
                            <ul className="subject-info-list list-unstyled d-flex mb-1">
                                <li>
                                    <div className="sub-info-lst-row d-flex items-baseline" style={{ paddingBottom: "8px" }}>
                                        <div className="sub-info-lst-lft">
                                            <span className="sub-icon">
                                                {/* {row.subjectStatus != "Not Yet Published" ?  */}
                                                <i className="fal fa-calendar-clock" style={{ fontSize: "10px" }}></i>
                                                {/* : (<i></i>)} */}
                                            </span>
                                        </div>
                                        <div className="sub-info-lst-rgt" style={{paddingRight:"10px"}}>
                                            {row.subject_type === "mentored" && isAdmin !== 1 ? (
                                                (() => {
                                                    switch (row.student_intake_status) {
                                                        case 0:
                                                            return (
                                                                <>
                                                                    <small>Recommended Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                        case 1:
                                                        case 4:
                                                            return (
                                                                <>
                                                                    <small>Committed Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                        case 2:
                                                        case 3:
                                                            return (
                                                                <>
                                                                    <small>Completion Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                        default:
                                                            return (
                                                                <>
                                                                    <small>Recommended Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                    }
                                                })()
                                            ) : (
                                                <>
                                                        {row.hide_dates && (row.subjectStatus === "Not Yet Published" && isAdmin !== 1) ? (
                                                            <p>-</p>
                                                        ) : (
                                                            <>
                                                                <p>{row.start && row.end ? formatDateRangeShort(row.start, row.end) : "Invalid Date"}</p>
                                                            </>
                                                        )}
                                                </>
                                            )}
                                        </div>
                                    </div>  
                                </li>
                                {row.subject_type === "mentored" ?
                                (
                                <li className="status-detail-li">
                                    <div className="sub-info-lst-row" style={{ display: "flex", justifyContent: "start", alignItems: "center", height: "100%", paddingLeft: "17px", }}>
                                        {renderStatusChip(row)}
                                    </div>
                                </li>
                                ) : ""}
                            </ul>
                            {row.subject_type !== "mentored" ? renderStatusChip(row) : "-"}
                        </SubjectSideCard>
                    )
                })}
            </>
        </>)
}

export default PastSubjectList